import React from 'react';
import { HomeOutlined, InfoCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import './HeaderPageMessage.scss';

const HeaderPageMessage = ({ section, message, title, header, fields }) => {
  return (
    <div className="container-headerPageMessage">
      <div>
        <HomeOutlined style={{ fontSize: '13px' }} /> |{' '}
        <span style={{ color: '#AAAAAA', fontSize: '13px' }}>{section}</span> |{' '}
        <span style={{ color: '#c12b7d', fontSize: '13px' }}>{title}</span>
      </div>
      {title && <h1 className="title-label">{title}</h1>}
      <div className="message-label">
        <span>
          <InfoCircleOutlined style={{ color: '#c12b7d', marginRight: '0.5rem' }} />
          {message}.
        </span>
        <span style={{ color: 'red' }}> *{fields}.</span>
      </div>
      <span className="header-label">{header}</span>
    </div>
  );
};

HeaderPageMessage.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  section: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  fields: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

HeaderPageMessage.defaultProps = {
  title: '',
  header: '',
  section: '',
  message: null,
  fields: null
};

export default HeaderPageMessage;
